var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.6875,
    r: 30,
    fill: "#076EB2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6441_7317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 13.1875C25.3586 13.1875 20.9074 15.0312 17.6256 18.3131C14.3437 21.5949 12.5 26.0461 12.5 30.6875C12.5 35.3289 14.3437 39.7801 17.6256 43.0619C20.9074 46.3438 25.3586 48.1875 30 48.1875C34.6414 48.1875 39.0926 46.3438 42.3744 43.0619C45.6563 39.7801 47.5 35.3289 47.5 30.6875C47.5 26.0461 45.6563 21.5949 42.3744 18.3131C39.0926 15.0312 34.6414 13.1875 30 13.1875ZM30 45.2708C26.1322 45.2708 22.4229 43.7344 19.6882 40.9993C16.9532 38.2645 15.4167 34.555 15.4167 30.6875C15.4167 26.82 16.9531 23.1104 19.6882 20.3757C22.423 17.6407 26.1325 16.1042 30 16.1042C33.8675 16.1042 37.5771 17.6406 40.3118 20.3757C43.0468 23.1105 44.5833 26.82 44.5833 30.6875C44.5833 33.2475 43.9095 35.7621 42.6295 37.9792C41.3496 40.1961 39.5086 42.0372 37.2916 43.3171C35.0746 44.597 32.56 45.2709 29.9999 45.2709L30 45.2708ZM36.1398 34.7561C36.4485 35.0204 36.6327 35.4014 36.6484 35.8074C36.6642 36.2135 36.5097 36.6077 36.2224 36.8949C35.9352 37.1822 35.541 37.3367 35.1349 37.3209C34.7289 37.3052 34.3479 37.121 34.0835 36.8123L28.9794 31.7081C28.7046 31.439 28.5473 31.072 28.5419 30.6873L28.5419 20.479C28.5419 19.9579 28.8199 19.4765 29.271 19.216C29.7222 18.9555 30.2782 18.9555 30.7294 19.216C31.1806 19.4765 31.4585 19.9579 31.4585 20.479L31.4585 30.0892L36.1398 34.7561Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6441_7317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 50 10.6875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/TimeIcon.c6a74c35fd4e0c7a9fdf3e17b3a25f1a.svg";
export { ForwardRef as ReactComponent };